var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c("div", { staticClass: "container has-text-dark" }, [
      _c("div", { staticClass: "is-size-3" }, [_c("b", [_vm._v("Trial")])]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.assigned,
              expression: "!assigned"
            }
          ],
          staticClass: "top20"
        },
        [
          _c("div", [
            _vm._v("To begin your 14 day trial trial of the sllink "),
            _c("b", [_vm._v('"' + _vm._s(_vm.item.tgtSlink) + '"')]),
            _vm._v(
              " please provide the URL you would like us to redirect it to."
            )
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v("You can then promote your slinks as "),
            _c("b", [_vm._v("slink.com/" + _vm._s(_vm.item.tgtSlink))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "top20" }, [_vm._v(" Enter URL:")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.url,
                expression: "url"
              }
            ],
            staticClass: "input has-background-dBlue",
            attrs: { type: "text" },
            domProps: { value: _vm.url },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.url = $event.target.value
              }
            }
          }),
          _c("br"),
          _vm._v(" "),
          _c("button", { staticClass: "button is-warning" }, [_vm._v("GO")])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "top20" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.assigned,
                expression: "assigned"
              }
            ],
            staticClass: "is-size-4"
          },
          [
            _vm._v("\n                Great! Your slink is ready to go!"),
            _c("br"),
            _vm._v("\n                -->Provide ideas of how to use It"),
            _c("br"),
            _vm._v(
              "\n                If you want to change the URL to which your slink points to for free during the trial, please register for an account with the same email you used for this trial."
            ),
            _c("br"),
            _vm._v(" "),
            _c("button", { staticClass: "button is-warning" }, [
              _vm._v("REGISTER NOW")
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b41fc22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b41fc22","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Trial.vue
// module id = null
// module chunks = 